
import { Marker, Tooltip } from 'react-leaflet';
import useZoomLevel from '../../Optics/Markers/useZoomLevel';
import { useRef } from 'react';
import { CONST_HIGHWAY, CONST_CANTON, PON_BOX } from '../../Optics/Constants/ConstantsOptics';
import ShowEditingCoorComponent from '../../Optics/Drawing/ShowEditingCoorComponent';
import { UpdatePonBoxCoordinateConstruction } from '../WriteData/UpdateConstructCommunications';

const MarkersViewingPonBoxConstructor = ({ data, icon, layersVisibilityCommunications, isLineDrawing, flag,
  openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, type, user, cantonRefresh,
  highwayRefresh, isComponentСhangeCoor, setIsComponentСhangeCoor, showPonLayer, showKtvLayer, showEtherLayer, visibleNumberPonBox}) => {


    const zoomLevel = useZoomLevel();
    const newCoordinates = useRef({}); 
  
    const handleMarkerDragEnd = (event, id) => {
      if (!isComponentСhangeCoor) return; 
    
      const { lat, lng } = event.target.getLatLng();
      newCoordinates.current = {};
      newCoordinates.current = { id, lat, lng, type };     
    };
  
    const handleSave = () => {
      const { id, lat, lng, type } = newCoordinates.current;
    
     if(type === PON_BOX) {
      if (statusModalTerritory === CONST_CANTON) {
        UpdatePonBoxCoordinateConstruction(id, lat, lng, user, cantonRefresh);
      }
    }else{
      console.log("Не определено ", type);
    }
  
      newCoordinates.current = {};
      setIsComponentСhangeCoor(false); 
    };
  
    return (
      <>

{data.map((item, index) => {
  const eventHandlers = {};
  if (!isLineDrawing && !flag) {
    eventHandlers.click = () => {
      let content = '';
      if (statusModalTerritory === CONST_HIGHWAY) {
        content = highwayFlag;
      } else if (statusModalTerritory === CONST_CANTON) {
        content = cantonFlag;
      }
      openModalWithContent(item, content);
    };
  }

  if (zoomLevel <= 16) {
    return null;
  }


  const shouldDisplayMarker =
  layersVisibilityCommunications &&
  (
    (showPonLayer && item.pon === 1) || 
    (showKtvLayer && item.ktv === 1) || 
    (showEtherLayer && item.ether === 1) ||
    (!showPonLayer && !showKtvLayer && !showEtherLayer && item.nodeStatus !== 1)
  );

  if (!shouldDisplayMarker) {
    return null;
  }

  return (
    <Marker
      key={index}
      position={[item.latitude, item.longitude]}
      icon={icon}
      draggable={isComponentСhangeCoor}
      eventHandlers={{
        click: eventHandlers.click,
        dragend: (event) => handleMarkerDragEnd(event, item.id),
      }}
    >
    {visibleNumberPonBox && item.numberBox !== null && (
      <Tooltip permanent direction="bottom" offset={[0, 10]} className="custom-tooltipPonNumber">
        {item.numberBox}
      </Tooltip>
    )}
    </Marker>
  );
})}
  
        {/* Компонент для сохранения или отмены изменений */}
        <ShowEditingCoorComponent
          isComponentСhangeCoor={isComponentСhangeCoor}
          setIsComponentСhangeCoor={setIsComponentСhangeCoor}
          handleSave={handleSave} 
        />
      </>
    );
  };
  
  export default MarkersViewingPonBoxConstructor;